module.exports = __webpack_public_path__ + "static/katie-Fun-17c9e1190c7cac065560b07543fd575f.jpg";